import React from 'react';
import PropTypes from 'prop-types';
import { createRefetchContainer, graphql } from 'react-relay';
import { Translate } from '@hydra/common/components';
import get from 'lodash/get';

import Http4xxErrorsRow from '../Http4xxErrorsRow';
import CrawlerTable from '@hydra/routes/crawler/components/CrawlerTable';

import FilterContainer from '@hydra/routes/crawler/components/FilterContainer';
import FilterCheckboxes from '@hydra/routes/crawler/components/FilterCheckboxes';
import FilterString from '@hydra/routes/crawler/components/FilterString';
import { withFilters } from '@hydra/routes/crawler/components/withFilters';

export class Http4xxErrorsTable extends React.Component {
  static propTypes = {
    relay: PropTypes.object,
    project: PropTypes.shape({
      crawl: PropTypes.shape({
        httpStatusCategory: PropTypes.shape({
          countCodesHttp4xxErrors: PropTypes.arrayOf(
            PropTypes.shape({
              count: PropTypes.number,
              code: PropTypes.number
            })
          ),
          http4xxErrors: PropTypes.shape({
            count: PropTypes.number,
            edges: PropTypes.arrayOf(
              PropTypes.shape({
                node: PropTypes.object
              })
            )
          })
        })
      })
    }).isRequired,
    offset: PropTypes.number,
    limit: PropTypes.number
  }

  render () {
    const toggles = get(this.props.project, 'crawls.edges[0].node.countCodesHttp4xxErrors', [])
      .map(v => ({ identifier: v.code, ...v }));
    return (
      <>
        <FilterContainer>
          <FilterCheckboxes
            onChange={this.props.onGraphQLCheckboxInputChange('codeFilters', toggles)}
            checkedItems={this.props.filters.codeFilters}
            groups={toggles}
            name='codeFilters'
            label={<Translate content='crawler_http_code' />}
          />

          <FilterString
            onChange={this.props.onGraphQLInputChange('errorUrl')}
            value={this.props.filters.errorUrl}
            name='errorUrl'
            label={<Translate content='crawler_error_page_url' />}
          />

          <FilterString
            onChange={this.props.onGraphQLInputChange('sourceUrl')}
            value={this.props.filters.sourceUrl}
            name='sourceUrl'
            label={<Translate content='crawler_source_page_url' />}
          />
        </FilterContainer>
        <CrawlerTable {...this.props} category='httpStatusCategory' section='http4xxErrors'>
          <CrawlerTable.TableHead>
            <Translate content='crawler_http_code' size='1' />
            <Translate content='crawler_error_page_url' size='5' />
            <Translate content='crawler_source_page_url' size='6' />
          </CrawlerTable.TableHead>
          <CrawlerTable.Body component={Http4xxErrorsRow} />
        </CrawlerTable>
      </>
    );
  }
}

const WithFiltersHttp4xxErrorsTable = (withFilters)(Http4xxErrorsTable);

export default createRefetchContainer(
  WithFiltersHttp4xxErrorsTable,
  {
    project: graphql`
      fragment Http4xxErrorsTable_project on Project
      @argumentDefinitions(
        offset: {type: "Int", defaultValue: 0},
        limit: {type: "Int", defaultValue: 20},
        codeFilters: {type: "[Int]", defaultValue: []},
        errorUrl: {type: "TextFilters", defaultValue: { operator: AND, values: [] }},
        sourceUrl: {type: "TextFilters", defaultValue: { operator: AND, values: [] }},
        linkTypeFilter: {
          type: "LinkTypeFilter",
          defaultValue: { showInternal: true, showExternal: true }
        }
      ) {
        host,
        crawls (offset: 0, limit: 1) {
          edges {
            node {
              countCodesHttp4xxErrors(linkTypeFilter: $linkTypeFilter, errorUrl: $errorUrl, sourceUrl: $sourceUrl) {
                code
                count
              }
              http4xxErrors (offset: $offset, limit: $limit, codeFilters: $codeFilters, linkTypeFilter: $linkTypeFilter, errorUrl: $errorUrl, sourceUrl: $sourceUrl) {
                count
                edges {
                  node {
                    ...Http4xxErrorsRow_issue
                  }
                }
              }
            }
          }
        }
      }
    `
  },
  graphql`
      query Http4xxErrorsTable_RefetchQuery(
        $host: String!
        $limit: Int,
        $offset: Int,
        $codeFilters: [Int],
        $linkTypeFilter: LinkTypeFilter,
        $sourceUrl: TextFilters,
        $errorUrl: TextFilters) {,
        project (host: $host) {
          ...Http4xxErrorsTable_project @arguments(
            offset: $offset,
            limit: $limit,
            codeFilters: $codeFilters,
            linkTypeFilter: $linkTypeFilter,
            errorUrl: $errorUrl,
            sourceUrl: $sourceUrl
          )
        }
      }
    `
);
